<template>
  <div class="product-wrapper">
    <div class="product">
      <div class="tag" v-if="series.new"><span>New</span></div>
      <div class="image" :style="[series.image !== null ? {'background-image': 'url(' + series.image + ')'} : '']" @click="goTo(seriesLink)"></div>
      <div class="content">
        <h3 style="text-align: center;" data-localizer="ignore">{{ series.title }}</h3>
        <p class="description" v-if="series.subtitle !== null">{{ series.subtitle }}</p>
      </div>
      <div class="buttons">
        <a :href="seriesLink" title="More Detail" class="btn-red">More Detail</a>

        <a v-if="series.compared" href="/compare" title="Compare" class="btn-dark-grey">View List</a>
        <a v-else @click="addToCompare(series.id)" title="Compare" class="btn-light-grey">Compare</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeriesCard',
  props: {
    series: Object,
    partNumberFilter: String
  },
  computed: {
    seriesLink: function () {
      if (this.partNumberFilter.length) {
        return this.series.url + '?sku=' + this.partNumberFilter
      } else {
        return this.series.url
      }
    }
  },
  methods: {
    addToCompare: function (seriesId) {
      this.$emit('addToCompare', seriesId)
    },
    removeFromCompare: function (seriesId) {
      this.$emit('removeFromCompare', seriesId)
    },
    goTo: function (url) {
      document.location = url
    }
  }
}
</script>
